export default __webpack_public_path__ + "static/media/user1.f1d4434c.png";